import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 25 24"

const AccountIconFilled = createSvgIcon(
  <>
    <path d='M12.1 14.2c2.6 0 4.7-2.4 4.7-5.3s-2.1-5.3-4.7-5.3S7.4 6 7.4 8.9s2.1 5.3 4.7 5.3z' />
    <path d='M12.1 0C5.5 0 .1 5.4.1 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12zm0 1c6.1 0 11 4.9 11 11 0 2.5-.9 4.9-2.3 6.7-1.2-2.1-3.4-3.3-5.8-3.3H9.3c-2.4 0-4.6 1.3-5.8 3.4C2 16.9 1.1 14.6 1.1 12c0-6.1 4.9-11 11-11z' />
  </>,
  'AccountIconFilled'
)

export default AccountIconFilled
